import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var AddDoctorRes;
export const AddDoctorTodo = createAsyncThunk('AddDoctor', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'admin/doctor',
            data: data,
            headers: { "Content-Type": "multipart/form-data",  "Authorization": 'Bearer ' + localStorage.getItem('user_token')}
        })
        return AddDoctorRes = res.data
        
    } catch (error) {
        return AddDoctorRes = error.response.data
    }
})